import { Box, FormControlLabel, Switch, Typography } from "@mui/material";

export const CustomFormSwitch = ({
  formik,
  name,
  label,
  disabled = false,
  checked,
  onChange,
}) => {
  const isControlledExternally = formik === undefined;

  const value = isControlledExternally ? checked : formik.values[name];
  const error =
    !isControlledExternally && formik.touched[name] && formik.errors[name];

  const handleChange = (e) => {
    if (isControlledExternally) {
      onChange?.(e);
    } else {
      formik.setFieldValue(name, e.target.checked);
    }
  };

  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={Boolean(value)}
            onChange={handleChange}
            disabled={disabled}
          />
        }
        label={
          <Typography fontSize="0.85rem" color="text.secondary">
            {label}
          </Typography>
        }
      />

      {error && (
        <Typography variant="caption" color="error" sx={{ ml: 0.5 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};
